export const WhiteWrapper = {
  // padding: '20px',
  // padding: "20px 0 20px 10px",
  borderRadius: '1px',
  bgcolor: "#FFFFFF"
}
export const WidthFour = {
  width:'400px'
}